import { useNavigate } from "@tanstack/react-router";
import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "./dialog";

interface LoginRequiredDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export function LoginRequiredDialog({
	open,
	onOpenChange,
}: LoginRequiredDialogProps) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleSignupClick = () => {
		onOpenChange(false);
		navigate({ to: "/auth/signup" });
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 mb-4">
						<LogIn className="h-6 w-6 text-primary" />
					</div>
					<DialogTitle className="text-center text-xl font-semibold">
						{t("auth.login_required.title")}
					</DialogTitle>
					<DialogDescription className="text-center text-muted-foreground">
						{t("auth.login_required.description")}
					</DialogDescription>
				</DialogHeader>

				<DialogFooter className="flex-col gap-1 sm:flex-col">
					<Button
						onClick={handleSignupClick}
						className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
					>
						{t("auth.login_required.create_account")}
					</Button>
					<Button
						variant="link"
						onClick={() => navigate({ to: "/auth/signin" })}
					>
						{t("auth.login_required.already_user")}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
